// Libs
import React, { useEffect, useState } from 'react';
import { Tooltip, Modal } from 'antd';
import { useRecoilValue, useSetRecoilState } from 'recoil';

// Own Libs
import { Button, Row } from '@digital/ui';

//Api
import { getComentariosNegociacaoMinuta, ISasPropostaOrdemCompra, ISasPropostaOrdemCompraDocs, salvarComentarioNegociacaoMinuta, validarEnvioNegociacaoMinutaContratual } from '@app/api/sas/sasProposta';

//Files
import { Visibility } from '@app/components';
import ListMensagem from './ComentariosParecerTecnico/ListMensagem';

//Utils

interface Props {
    sasProposta: ISasPropostaOrdemCompra;
}

export const ModalComunicacaoMinutaContratualFornecedor = ({ sasProposta }: Props) => {

    const [exibirModal, setExibirModal] = useState(false);

    const handleCancel = () => {
        setExibirModal(false);
    };

    const [comentarios, setComentarios] = useState([]);
    const carregarComentarios = () => {
        getComentariosNegociacaoMinuta(sasProposta.id).then(setComentarios);
    };

    useEffect(() => {

        if (exibirModal) {
            carregarComentarios();
        }
    }, [exibirModal]);

    return (
        <Visibility visible={true}>
            <Row align='middle' justify='center' style={{ display: 'flex' }} >

                <Tooltip title="Comunicação com Fornecedor">
                    <Button icon='business-set_as_resume' onClick={() => { setExibirModal(true); }} />
                </Tooltip>

            </Row>

            <Visibility visible={exibirModal} >

                <Modal
                    title="Comunicação com Fornecedor"
                    width='780px'
                    visible={exibirModal}
                    onCancel={handleCancel}
                    footer={null}
                >
                    <Row style={{ marginTop: 16 }}>
                        <strong>Comunicação com o Fornecedor</strong>
                        <Row style={{ maxHeight: 200, overflowY: 'auto', border: '1px solid #f0f0f0', padding: 8, marginTop: 8 }}>
                            <ListMensagem mensagens={comentarios} />
                        </Row>
                    </Row>
                </Modal>
            </Visibility>
        </Visibility>
    );
};